export const DAPI_ROOT_URL = 'https://leazardcloud.com/production';
export const DAPI_DEV_ROOT_URL = 'https://leazardcloud.net/dev';

export function getDapiRootUrl() {
  return window.location.host.includes('localhost') ? DAPI_DEV_ROOT_URL : DAPI_ROOT_URL;
}
